import { cx } from '../cx'
import styles from './ConsequenceSlot.module.css'

export type ConsequenceLevelName = 'mild' | 'moderate' | 'severe'

export interface ConsequenceSlotProps {
  /** Styling band only. Extreme shares Severe's treatment; see `label`. */
  level: ConsequenceLevelName
  /**
   * The text shown on the slot. Defaults to `level`, but must be passed whenever
   * the domain's name differs from the band — an Extreme consequence styles like
   * a Severe one and must still read "Extreme".
   */
  label?: string | undefined
  /** The consequence text. Absent = the slot is open. */
  text?: string
  onClick?: () => void
  disabled?: boolean
  className?: string | undefined
}

/**
 * Spec §4 "Consequence slot". Empty reads "open" in a neutral outline; filled
 * takes a warm rust fill and holds the consequence text — which is itself an
 * invokable aspect against its owner.
 */
export function ConsequenceSlot({
  level,
  label,
  text,
  onClick,
  disabled = false,
  className,
}: ConsequenceSlotProps) {
  const filled = text !== undefined && text.length > 0
  const interactive = onClick !== undefined && !disabled
  const Tag = interactive ? 'button' : 'div'

  return (
    <Tag
      {...(interactive ? { type: 'button' as const, onClick, disabled } : {})}
      className={cx(styles.slot, filled ? styles.filled : styles.open, className)}
    >
      <span className={styles.level}>{label ?? level}</span>
      <span className={cx(styles.text, !filled && styles.placeholder)}>
        {filled ? text : 'open'}
      </span>
    </Tag>
  )
}
